import React from 'react';
import moment from 'moment';
import { Card } from 'react-toolbox/lib/card';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import FontIcon from 'react-toolbox/lib/font_icon';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import Tooltip from 'react-toolbox/lib/tooltip';
import Link from 'react-toolbox/lib/link';
import Input from 'react-toolbox/lib/input';
import { get } from 'lodash';
import Dialog from '~/components/Dialog';

import { findUserById } from '~/actions/user';

import {
  orderRefresh,
  pickItem,
  boxResetStatus,
  boxReset,
  addTracking
} from '~/actions/orders';

import noImg from './noimage.jpg';
import Styles from './order.scss';

const TooltipLink = Tooltip(Link);

const stateTranslate = {
  notstarted: 'Not started',
  pickStart: 'Started picking',
  pickPause: 'Picking paused',
  pickStop: 'Done picking',
  qaStart: 'QA started',
  qaPause: 'Paused QA',
  qaStop: 'Done with QA',
  pickMiss: 'Order was miss picked',
  shippedStart: 'Started delivery',
  shippedPause: 'Paused delivery',
  shippedStop: 'Delivery done',
  pickedUp: 'Marked as picked up'
};

class Order extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);

    const boxFields = {};
    const fieldsToAdd = ['trackingCode'];
    props.item.boxes.forEach(box => {
      const { boxId } = box;
      fieldsToAdd.forEach(field => {
        if (typeof boxFields[boxId] === 'undefined') {
          boxFields[boxId] = {};
        }
        boxFields[boxId][field] = box[field] || null;
      });
    });

    this.state = {
      more: false,
      updateStamp: 0,
      showEdit: false,
      boxActivitiesOpened: {},
      boxResetOpen: false,
      boxResetStatusOpen: false,
      initialBoxFields: boxFields,
      boxFields
    };
  }

  onBoxFieldChange(boxId, fieldName, val) {
    const { boxFields } = this.state;
    this.setState({
      boxFields: {
        ...boxFields,
        [boxId]: { ...boxFields[boxId], [fieldName]: val || null }
      }
    });
  }

  setDescription(description) {
    return { __html: description };
  }
  getStatusTypes(status) {
    const out = {
      notStarted: true,
      picker: false,
      qa: false,
      shipped: false
    };
    /* eslint no-fallthrough: 0 */
    switch (status) {
      case 'shippedStop':
        out.shipped = true;
      case 'shippedStart':
      case 'shippedPause':
      case 'qaStop':
      case 'qaPause':
      case 'qaStart':
        out.qa = true;
      case 'pickStop':
      case 'pickPause':
      case 'pickStart':
        out.picker = true;
        break;
      default:
        break;
    }
    return out;
  }

  getUser(userId) {
    const user = this.props.user.getIn(['users', userId], false);
    if (!user) {
      // fetch the user info
      findUserById(this.props.dispatch, this.context.apiClient, userId);
      return { name: 'Loading' };
    }
    return user.toJS();
  }

  toggleMore() {
    this.setState({ more: !this.state.more });
  }

  toggleEdit() {
    this.setState({ showEdit: !this.state.showEdit });
  }

  generateImgURI(uri) {
    const img = `https://www.partynuts.com/thumbnail.asp?file=${uri.replace(
      'https://www.partynuts.com/',
      ''
    )}&maxx=50&maxy=0`;
    return img;
  }

  isBoxFieldDirty(boxId, fieldName) {
    const { state } = this;
    return (
      get(state, `boxFields.${boxId}.${fieldName}`) !==
      get(state, `initialBoxFields.${boxId}.${fieldName}`)
    );
  }

  saveTrackingCode(boxId) {
    const trackingCode = get(
      this.state.boxFields,
      `${boxId}.trackingCode`,
      null
    );
    addTracking(
      this.props.dispatch,
      this.context.apiClient,
      this.props.item.orderId,
      boxId,
      trackingCode
    ).then(() => {
      const { initialBoxFields } = this.state;
      this.setState({
        initialBoxFields: {
          ...initialBoxFields,
          [boxId]: { ...initialBoxFields[boxId], trackingCode }
        }
      });
    });
  }

  rehreshOrder() {
    orderRefresh(
      this.props.dispatch,
      this.context.apiClient,
      this.props.item.shopId
    );
  }

  pickItemBtn(itemId, boxId, mode, negative) {
    const { item } = this.props;
    pickItem(
      this.props.dispatch,
      this.context.apiClient,
      item.orderId,
      boxId,
      itemId,
      mode,
      true,
      negative
    );
  }
  renderHistory(list) {
    return (
      <table className={Styles.orderTable}>
        <thead>
          <tr>
            <th>
              <div className={Styles.spacer} />
            </th>
            <th>When</th>
            <th>Box Id</th>
            <th>What</th>
            <th>Who</th>
          </tr>
        </thead>
        <tbody>
          {list &&
            list.map(item => {
              const user = this.getUser(item.userId);
              return (
                <tr key={item.stamp}>
                  <td>
                    <div className={Styles.spacer} />
                  </td>
                  <td>{moment(item.stamp).format('LLL')}</td>
                  <td>{item.boxId}</td>
                  <td>
                    {stateTranslate[item.state] || item.state}
                    {item.reason && (
                      <div className={Styles.historyReason}>
                        {(() => {
                          if (typeof item.reason === 'object') {
                            return (
                              <div>
                                {item.reason.selectedReason && (
                                  <div>
                                    Reason: {item.reason.selectedReason}
                                  </div>
                                )}
                                {item.reason.comment && (
                                  <div>Comment: {item.reason.comment}</div>
                                )}
                                {item.state === 'pickMiss' &&
                                  (() => {
                                    const blames = item.reason.blames || [];
                                    return (
                                      blames.length > 0 && (
                                        <div>
                                          <div>Misspicked by:</div>
                                          {blames.map(blame => {
                                            const blameUser = this.getUser(
                                              blame.userId
                                            );
                                            return (
                                              <div
                                                key={`blame_${blame.userId}`}
                                              >
                                                {blameUser.name}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      )
                                    );
                                  })()}
                              </div>
                            );
                          }
                          return item.reason;
                        })()}
                      </div>
                    )}
                  </td>
                  <td>{user.name}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
    );
  }
  renderBoxes(boxes) {
    const boxList = [];
    const iconStyle = {
      color: '#eee'
    };
    Object.keys(boxes).forEach(key => {
      const item = boxes[key];
      const order = this.props.item;
      const history = (order.History || []).filter(h => h.boxId === item.boxId);
      const visState = this.getStatusTypes(item.status);
      const boxOfBox =
        (item.boxVis && `${item.boxVis} / ${boxes.length}`) || item.boxId;
      const { boxActivitiesOpened } = this.state;
      const boxActivitiesOpen = !!boxActivitiesOpened[item.boxId];
      boxList.push(
        <div key={item.boxId}>
          <div className={Styles.subSubtitle}>
            Box: {boxOfBox}
            {item.boxId > 0 && (
              <span className={Styles.boxId}>Box ID: {item.boxId}</span>
            )}
            <div>
              <div className={Styles.boxState}>
                <div className={Styles.grey}>State</div>
                <div>
                  <FontIcon
                    value="inbox"
                    style={(visState.notStarted && {}) || iconStyle}
                  />
                  <FontIcon
                    value="archive"
                    style={(visState.picker && {}) || iconStyle}
                  />
                  <FontIcon
                    value="done_all"
                    style={(visState.qa && {}) || iconStyle}
                  />
                  <FontIcon
                    value="airplanemode_active"
                    style={(visState.shipped && {}) || iconStyle}
                  />
                </div>
              </div>
              <div className={Styles.boxProgress}>
                <div className={Styles.grey}>Progress</div>
                <div className={Styles.progressBox}>
                  <div className={Styles.progressSubtitle}>Pick</div>
                  <ProgressBar
                    type="linear"
                    mode="determinate"
                    value={
                      (item.percent &&
                        item.percent.pick &&
                        Math.round(item.percent.pick * 100)) ||
                      0
                    }
                  />
                </div>

                <div className={Styles.progressBox}>
                  <div className={Styles.progressSubtitle}>QA</div>
                  <ProgressBar
                    type="linear"
                    mode="determinate"
                    value={
                      (item.percent &&
                        item.percent.qa &&
                        Math.round(item.percent.qa * 100)) ||
                      0
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={Styles.boxActions}>
            {order.boxes.length > 1 && (
              <Button
                icon={boxActivitiesOpen ? 'expand_less' : 'expand_more'}
                label={boxActivitiesOpen ? 'Hide activity' : 'Show activity'}
                raised
                onClick={() => {
                  this.setState({
                    boxActivitiesOpened: {
                      ...boxActivitiesOpened,
                      [item.boxId]: !boxActivitiesOpen
                    }
                  });
                }}
              />
            )}
            <Button
              icon="print"
              label="Print"
              raised
              primary
              onClick={() => {
                const pdf = `${CONFIG.api_url}/pdf/order/${
                  this.props.item.orderId
                }/${item.boxId}`;
                window.open(pdf);
              }}
            />
          </div>

          <div className={Styles.boxActivity}>
            {boxActivitiesOpen && this.renderHistory(history)}
          </div>

          <table className={Styles.orderTable}>
            <thead>
              <tr>
                <th>
                  <div className={Styles.spacer} />
                </th>
                <th>Image</th>
                <th>Item ID</th>
                <th>Description</th>
                <th>Quantity</th>
                <th>Picked</th>
                <th>QA</th>
              </tr>
            </thead>
            <tbody>{item.items && this.renderItems(item.items)}</tbody>
          </table>
        </div>
      );
    });
    return boxList;
  }

  renderBoxesEdit(boxes) {
    const boxList = [];
    const level = this.props.user.getIn(['self', 'level'], 10000);
    const { boxFields } = this.state;
    Object.keys(boxes).forEach(key => {
      const item = boxes[key];
      const { boxId } = item;
      const notStarted = item.status === 'notstarted';
      const fields = get(boxFields, boxId, {});
      boxList.push(
        <div key={boxId}>
          <div className={Styles.boxEditSubtitle}>
            Box: {(item.boxVis && `${item.boxVis} / ${boxes.length}`) || boxId}
          </div>
          {level <= 1000 && (
            <div>
              <div className={Styles.boxEditAdminActions}>
                {!notStarted && (
                  <Button
                    icon="replay"
                    label="Reset state"
                    raised
                    accent
                    onClick={() =>
                      this.props.dispatch({
                        type: 'CONFIRMATION_SHOW',
                        msg:
                          'Are you sure you want to reset the state of this box?',
                        onOk: () =>
                          boxResetStatus(
                            this.props.dispatch,
                            this.context.apiClient,
                            this.props.item.orderId,
                            boxId
                          )
                      })
                    }
                  />
                )}
                <Button
                  icon="replay"
                  label="Reset picked and QA"
                  raised
                  accent
                  onClick={() =>
                    this.props.dispatch({
                      type: 'CONFIRMATION_SHOW',
                      msg: 'Are you sure you want to reset this box?',
                      onOk: () =>
                        boxReset(
                          this.props.dispatch,
                          this.context.apiClient,
                          this.props.item.orderId,
                          boxId,
                          'both'
                        )
                    })
                  }
                />
              </div>
              <div className={Styles.boxEditAdminFields}>
                <Input
                  label="Tracking code"
                  value={fields.trackingCode || ''}
                  onChange={val =>
                    this.onBoxFieldChange(boxId, 'trackingCode', val)
                  }
                />
                {this.isBoxFieldDirty(boxId, 'trackingCode') && (
                  <div className={Styles.trackingCodeInfo}>
                    <div className={Styles.trackingCodeInfoText}>
                      Attention! An email will be sent to the customer when
                      changing the tracking code.
                    </div>
                    <div>
                      <Button
                        className={Styles.trackingCodeSave}
                        icon="save"
                        onClick={() => this.saveTrackingCode(boxId)}
                        raised
                        accent
                      >
                        Save and move to shipped
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          <table className={Styles.orderTable}>
            <thead>
              <tr>
                <th>
                  <div className={Styles.spacer} />
                </th>
                <th>Item ID</th>
                <th>Description</th>
                <th>Quantity</th>
                <th>Picked</th>
                <th>QA</th>
              </tr>
            </thead>
            <tbody>
              {item.items && this.renderItemsEdit(item.items, boxId)}
            </tbody>
          </table>
        </div>
      );
    });
    return boxList;
  }

  renderItems(list) {
    const itemList = [];
    let pos = 1;
    Object.keys(list).forEach(key => {
      pos += 1;

      const item = list[key];
      itemList.push(
        <tr key={`${item.sku}_${pos}`}>
          <td>
            <div className={Styles.spacer} />
          </td>
          <td>
            <img
              className={Styles.itemProduct}
              src={(item.img && this.generateImgURI(item.img)) || noImg}
              alt={key}
            />
          </td>
          <td>#{item.sku}</td>
          <td
            dangerouslySetInnerHTML={this.setDescription(
              item.title || item.sku
            )}
          />
          <td>{item.order}</td>
          <td>{item.pick}</td>
          <td>{item.qa}</td>
        </tr>
      );
    });
    return itemList;
  }

  renderItemsEdit(list, boxId) {
    const itemList = [];
    let pos = 1;
    Object.keys(list).forEach(key => {
      pos += 1;

      const item = list[key];
      itemList.push(
        <tr key={`${item.sku}_${pos}`}>
          <td>
            <div className={Styles.spacer} />
          </td>

          <td>#{item.sku}</td>
          <td
            dangerouslySetInnerHTML={this.setDescription(
              item.title || item.sku
            )}
          />
          <td>{item.order}</td>
          <td style={{ width: '110px' }}>
            {item.pick}
            <IconButton
              icon="add"
              onClick={() => this.pickItemBtn(item.sku, boxId, 'pick', false)}
              accent
            />
            <IconButton
              icon="remove"
              onClick={() => this.pickItemBtn(item.sku, boxId, 'pick', true)}
              accent
            />
          </td>
          <td style={{ width: '110px' }}>
            {item.qa}
            <IconButton
              icon="add"
              onClick={() => this.pickItemBtn(item.sku, boxId, 'qa', false)}
              accent
            />
            <IconButton
              icon="remove"
              onClick={() => this.pickItemBtn(item.sku, boxId, 'qa', true)}
              accent
            />
          </td>
        </tr>
      );
    });
    return itemList;
  }

  render() {
    const { item } = this.props;
    const mapOfStatus = this.props.statusList && this.props.statusList.toJS();
    const { more } = this.state;
    const actions = [
      {
        label: 'Refresh order',
        onClick: () => {
          this.rehreshOrder();
        }
      }
    ];
    const title = item.invoiceId
      ? `${item.invoiceId}`
      : `Order ID: ${item.shopId}`;
    const boxIds = (item.boxes || []).map(b => b.boxId);
    const orderHistory =
      item.boxes.length > 1
        ? (item.History || []).filter(h => !boxIds.includes(h.boxId))
        : item.History;
    const level = this.props.user.getIn(['self', 'level'], 10000);
    return (
      <div className={Styles.orderBox}>
        <Dialog
          active={this.state.showEdit}
          onEscKeyDown={() => this.toggleEdit()}
          onOverlayClick={() => this.toggleEdit()}
          onCloseButtonClick={() => this.toggleEdit()}
          actions={actions}
        >
          <div>{item.boxes && this.renderBoxesEdit(item.boxes, 'edit')}</div>
        </Dialog>
        <Card>
          <div className={Styles.shortInfoBox}>
            <div className={Styles.orderTitle}>
              {title}
              {!item.haveProductInfo && (
                <TooltipLink icon="warning" tooltip="Order need a refresh" />
              )}
            </div>
            <div className={Styles.orderShortInfo}>
              <div className={Styles.timeInfo}>
                <span className={Styles.grey}>Created: </span>
                {moment(item.orderDate).format('LLL')}
              </div>
              <div
                className={[Styles.timeInfo, 'hideTabletAndMobile'].join(' ')}
              >
                <span className={Styles.grey}>Added: </span>
                {moment(item.createdAt).format('LLL')}
              </div>
              <div
                className={[Styles.timeInfo, 'hideTabletAndMobile'].join(' ')}
              >
                <span className={Styles.grey}>Updated: </span>
                {moment(item.updatedAt).format('LLL')}
              </div>
            </div>
            <div className={Styles.status}>
              {mapOfStatus[item.OrderStatusID]}
            </div>

            <div className={Styles.progress}>
              <div className={Styles.grey}>Progress</div>
              <div className={Styles.progressBox}>
                <div className={Styles.progressSubtitle}>Pick</div>
                <ProgressBar
                  type="linear"
                  mode="determinate"
                  value={
                    (item.percent &&
                      item.percent.pick &&
                      Math.round(item.percent.pick * 100)) ||
                    0
                  }
                />
              </div>
              <div className={Styles.progressBox}>
                <div className={Styles.progressSubtitle}>QA</div>
                <ProgressBar
                  type="linear"
                  mode="determinate"
                  value={
                    (item.percent &&
                      item.percent.qa &&
                      Math.round(item.percent.qa * 100)) ||
                    0
                  }
                />
              </div>
            </div>

            <IconButton
              className={Styles.showMore}
              icon={(more && 'keyboard_arrow_up') || 'keyboard_arrow_down'}
              onClick={() => this.toggleMore()}
              accent
            />
          </div>
          {more && (
            <div>
              <div className={Styles.moreInfo}>
                <div className={Styles.subtitle}>Order details</div>

                <div>{item.boxes && this.renderBoxes(item.boxes)}</div>
              </div>
              <div className={Styles.moreInfo}>
                <div>
                  <div className={Styles.subtitle}>Activity for {title}</div>
                  <div>{this.renderHistory(orderHistory)}</div>
                </div>
              </div>
              <div className={Styles.boxActions}>
                {level <= 1500 && (
                  <Button
                    icon="refresh"
                    label="Refresh order"
                    primary
                    onClick={() => this.rehreshOrder()}
                  />
                )}
                {level <= 10 && (
                  <Button
                    icon="edit"
                    label="Edit"
                    primary
                    onClick={() => this.toggleEdit()}
                  />
                )}
                <Button
                  icon="print"
                  label="Print whole order"
                  primary
                  onClick={() => {
                    const pdf = `https://migration-api.sherpasystems.net/pdf/order/${
                      this.props.item.orderId
                    }`;
                    window.open(pdf);
                  }}
                />
              </div>
            </div>
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.getIn(['user'], {}),
  statusList: state.getIn(['orders', 'ecommStatusList', 'statusList'], {})
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps)(Order);



// WEBPACK FOOTER //
// ./app/pages/Orders/order.js